import { Component } from '@angular/core';

@Component({
  selector: 'cf-featured',
  templateUrl: './featured.component.html',
  styleUrls: ['./featured.component.scss'],
})
export class FeaturedComponent {}
